// The focus outline only for keyboard use (check-up, Kristi Nov 2: after a click it showed on
// Library copies' folds and the Columns menu, where a menu or a redraw moves focus by script).
// A tap or click puts the page in pointer mode, which hides the outline; any key that moves focus
// (Tab, the arrows, Enter, Space, Escape) brings it back at once.

const KEYS = new Set(['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', ' ', 'Escape', 'Home', 'End']);

export function watchFocusMode(doc: Document = document): () => void {
  const root = doc.documentElement;
  const pointer = () => root.classList.add('pointer-input');
  const key = (e: KeyboardEvent) => {
    if (KEYS.has(e.key)) root.classList.remove('pointer-input');
  };
  doc.addEventListener('pointerdown', pointer, true);
  doc.addEventListener('keydown', key, true);
  return () => {
    doc.removeEventListener('pointerdown', pointer, true);
    doc.removeEventListener('keydown', key, true);
  };
}
